/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const Wireless = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M91.346 75.415C84.32 68.446 74.656 64.132 64 64.132s-20.32 4.314-27.346 11.283c-.074.074-.149.147-.222.222l8.86 8.862c.073-.074.147-.15.222-.222C50.271 79.574 56.8 76.665 64 76.665c7.201 0 13.729 2.909 18.487 7.612.074.072.147.147.222.222l8.859-8.862-.222-.222z" />
    <path d="M109.063 57.701C97.498 46.19 81.566 39.066 64 39.066S30.503 46.191 18.937 57.7c-.074.073-.149.147-.222.222l8.858 8.858.222-.222c9.296-9.241 22.094-14.96 36.205-14.96s26.907 5.719 36.204 14.96c.074.074.149.147.222.222l8.858-8.858-.221-.221z" />
    <path d="M126.778 39.984C110.674 23.936 88.477 14 64 14S17.326 23.936 1.222 39.984L1 40.205l8.858 8.858.222-.222C23.914 35.063 42.978 26.533 64 26.533s40.086 8.531 53.92 22.31l.222.222L127 40.207l-.222-.223z" />
    <circle cx={64.074} cy={103.258} r={10.08} />
  </svg>
);

export default extendIcon(Wireless);
